import { axiosInstance } from "../../network/apis";
import { API } from "./../../utils/Constants";

// const handlerEnabled = false;
// Sample response
// import MenuSampleResponse from "./MenuSampleResponse";

export const getMenu = async (hotelKey, withTableId) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const headers = {
    "With-Table-Id": String(withTableId), // Convert to string to include 'true' or 'false'
  };

  const { data } = await axiosInstance.post(
    `${API.ENDPOINTS.GET_MENU}`,
    { id: `${hotelKey}`, timeZone: `${timeZone}` },
    {
      headers,
      handlerEnabled: false,
    }
  );
  // await axiosInstance.get(`${API.ENDPOINTS.GET_MENU}`, {
  //   handlerEnabled: false,
  // });

  // const data = MenuSampleResponse;
  if (data.status !== "success") {
    throw new Error(data.message);
  }
  return { data };
};

export const getLoyaltyMenu = async (payload) => {
  const { data } = await axiosInstance.post(
    `${API.ENDPOINTS.GET_USER_LOYALTY_PRODUCTS}`,
    { uid: `${payload?.uid}`, online_key: `${payload?.online_key}` },
    {
      handlerEnabled: false,
    }
  );
  // await axiosInstance.get(`${API.ENDPOINTS.GET_MENU}`, {
  //   handlerEnabled: false,
  // });

  // const data = MenuSampleResponse;

  if (data.status !== "success") {
    throw new Error(data.message);
  }
  return { data };
};

export const getProdSuggest = async (payload) => {
  const { data } = await axiosInstance.get(`${API.ENDPOINTS.PROD_SUGGEST}`, {
    params: {
      online_key: `${payload?.onlineKey}`,
      id: `${payload?.prodId}`,
    },
    handlerEnabled: false,
  });
  // await axiosInstance.get(`${API.ENDPOINTS.GET_MENU}`, {
  //   handlerEnabled: false,
  // });

  // const data = MenuSampleResponse;
  if (data?.status !== true) {
    throw new Error(data.message);
  }
  return { data };
};

export const getCartSuggest = async (payload) => {
  const { data } = await axiosInstance.get(`${API.ENDPOINTS.CART_SUGGESTION}`, {
    params: {
      online_key: `${payload?.onlineKey}`,
    },
    handlerEnabled: false,
  });
  // await axiosInstance.get(`${API.ENDPOINTS.GET_MENU}`, {
  //   handlerEnabled: false,
  // });

  // const data = MenuSampleResponse;
  if (data?.status !== true) {
    throw new Error(data.message);
  }
  return { data };
};

// New API functions for v2
export const getCategoriesV2 = async (restaurantId) => {
  console.log("API call - getCategoriesV2:", restaurantId);
  const url = `${API.ENDPOINTS.GET_CATEGORIES_V2}`;
  console.log("API URL:", url);
  
  const { data } = await axiosInstance.get(url, {
    params: {
      restaurant_id: restaurantId,
    },
    handlerEnabled: false,
  });

  console.log("API response - getCategoriesV2:", data);

  if (data.status !== "success") {
    throw new Error(data.message || "Failed to fetch categories");
  }
  return { data: data.data };
};

export const getProductsV2 = async (restaurantId, categoryId, page = 0, per_page = 3) => {
  console.log("API call - getProductsV2:", { restaurantId, categoryId, page });
  const url = `${API.ENDPOINTS.GET_PRODUCTS_V2}`;
  console.log("API URL:", url);
  
  const { data } = await axiosInstance.get(url, {
    params: { restaurant_id: restaurantId, category_id: categoryId, page: page, per_page: per_page },
    handlerEnabled: false,
  });

  console.log("API response - getProductsV2:", data);

  if (data.status !== "success") {
    throw new Error(data.message || "Failed to fetch products");
  }
  return { 
    data: data.data,
    pagination: data.pagination 
  };
};
